// @ts-nocheck
import { CompanyFilter } from "../types/companyFilter";
import { isEmpty } from "../../utils/jsUtils";

/**
 * Sanitizes company filters by including or excluding properties as needed.
 *
 * @param {CompanyFilter} companyFilters - The company filters object to be sanitized.
 * @param {boolean} [useThiccSearch=false] - Whether to apply additional search options.
 * @returns {CompanyFilter} - The sanitized company filters object.
 */

export const sanitizeCompanyFilters = (
  companyFilters: CompanyFilter,
  useThiccSearch = false
): CompanyFilter => {
  const copyOfCompanyFilters = JSON.parse(
    JSON.stringify(companyFilters)
  ) as CompanyFilter;

  if (useThiccSearch === false) {
    const productCategoryIds = copyOfCompanyFilters.productCategories?.ids;

    delete copyOfCompanyFilters.productCategories;

    copyOfCompanyFilters.productCategoryIds = isEmpty(productCategoryIds)
      ? undefined
      : productCategoryIds;

    for (const vendor of copyOfCompanyFilters.vendors || []) {
      delete vendor.departmentIds;
      delete vendor.roleIds;
    }

    for (const product of copyOfCompanyFilters.products || []) {
      delete product.departmentIds;
      delete product.roleIds;
    }
  }

  return copyOfCompanyFilters;
};
